export const common = {
    appName: "PrestaSlot",
    welcome: "Bienvenue",
    verify: "Vérifier",
    verifying: "Vérification...",
    login: "Connexion",
    signup: "Créer un compte",
    firstName: "Prénom",
    lastName: "Nom",
    email: "Email",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    rememberMe: "Se souvenir de moi",
    forgotPassword: "Mot de passe oublié?",
    or: "ou",
    businessName: "Nom de votre entreprise",
    businessType: "Type d'activité",
    termsAccept: "J'accepte les",
    termsLink: "conditions d'utilisation",
    privacyAccept: " et la",
    privacyLink: "politique de confidentialité",
    // SEO
    siteTitle: "PrestaSlot - Gestion de planning et réservations professionnelles",
    siteDescription: "Plateforme d'organisation en ligne pour professionnels. Gérez vos disponibilités, personnalisez vos services et recevez des réservations 24/7.",
    siteKeywords: "gestion de planning, réservations professionnelles, organisation en ligne, disponibilités, services personnalisés, réservations 24/7",
    alreadyHaveAccount: "Vous avez déjà un compte?",
    dontHaveAccount: "Vous êtes un professionnel et n'avez pas encore de compte?",
    loginAction: "Se connecter",
    signupAction: "Créer mon compte professionnel",
    features: "Fonctionnalités",
    solutions: "Solutions",
    pricing: "Tarifs",
    contact: "Contact",
    proAccount: "Espace Pro",
    professional: "Espace Pro",
    freeTrial: "Et bien plus encore ! Rejoins-nous !",
    seePricing: "Voir les tarifs",
    findProfessional: "Trouver un professionnel",
    tryForFree: "Essayer gratuitement",
    hero: "Accueil",
    testimonials: "Témoignages",
    myAccount: "Mon compte",
    createPassword: "Crée un mot de passe",
    imageUploadPlaceholder: "Glissez une image ou cliquez pour parcourir",
    characters: "caractères",
    reviewTutorial: "Revoir le tutoriel",
    mobileNotAvailable: "L'inscription ou l'accès au dashboard professionnel est disponible uniquement sur tablette ou PC. La version mobile sortira prochainement.",
    info: "Information pour les professionnels",
    retry: "Réessayer",
    close: "Fermer"
}

export const auth = {
    loginTitle: "Connecte-toi à ton espace PrestaSlot",
    signupTitle: "Inscrivez-vous pour proposer vos services à vos clients",
    loginVisualTitle: "Gère tes réservations sans effort",
    loginVisualText: "Connecte-toi pour accéder à ton tableau de bord et gérer tes rendez-vous.",
    signupVisualTitle: "Développement de ton activité",
    signupVisualText: "Rejoins les professionnels qui font confiance à PrestaSlot pour gérer leurs rendez-vous et développer leur clientèle.",
}

export const home = {
    hero: {
        title: "ON BOOSTE TON ORGANISATION PROFESSIONNELLE !",
        subtitle: "La solution idéale pour toi en tant que professionnel de la beauté qui veux se concentrer sur ton art plutôt que sur l'organisationnel.",
        trustedBy: "Déjà utilisé par plus de 200 professionnels",
        cta: {
            trial: "Optimise ton temps !",
            demo: "Demande une démo"
        }
    },
    features: {
        title: "Comment pouvons nous t'aider ?",
        subtitle: "Des outils simples et efficaces pour toi",
        featuresList: {
            dashboard: {
                title: "Tableau de bord intuitif",
                description: "Visualise en un coup d'œil tes rendez-vous du jour, tes revenus et les statistiques de ton activité.",
                bullet1: "Suivi de tes réservations du jour",
                bullet2: "Ajout d'un nouveau rendez-vous",
                bullet3: "Visualisation de tes recettes"
            },
            calendar: {
                title: "Calendrier intelligent",
                description: "Gère ton emploi du temps avec une vue claire et personnalisable de tes rendez-vous.",
                bullet1: "Visualisation de tes rendez-vous à la semaine",
                bullet2: "Annulation de tes rendez-vous",
                bullet3: "Ajout d'un rendez-vous"
            },
            services: {
                title: "Gestion des services",
                description: "Crée et personnalise tes services avec des options, des durées et des tarifs adaptés à ton activité.",
                bullet1: "Ajout de tes services avec ou sans options",
                bullet2: "Désactivation de tes services",
                bullet3: "Services sans créneau possible"
            },
            reservation: {
                title: "Suivi des réservations",
                description: "Consulte l'historique complet de tes réservations et gérez facilement les modifications ou annulations.",
                bullet1: "Filtrage de tes réservations",
                bullet2: "Analyse de tes réservations",
                bullet3: "Gestion des modifications"
            },
            bookingClient: {
                title: "Réservation client simplifiée",
                description: "Offre à tes clients une expérience de réservation fluide et intuitive, accessible 24h/24.",
                bullet1: "Réservation de services avec ou sans créneau",
                bullet2: "Pas de paiement sur l'application",
                bullet3: "Interface intuitive pour les clients"
            },
            availability: {
                title: "Gestion des disponibilités",
                description: "Définis tes créneaux récurrents ou ponctuels selon ton emploi du temps personnel.",
                bullet1: "Ajout de créneaux récurrents",
                bullet2: "Ajout de créneaux ponctuels à tout moment",
                bullet3: "Partage ton lien de réservation avec tes clients",
            }
        },
    },
    businessTypes: {
        title1: "Pour quels professionnels ?",
        subtitle: "Une solution pensée pour les professionnels de la beauté comme toi",
        request: "Tu ne te reconnais pas dans l'un de ces profils ?",
        text: "Ne t'en fais pas ! PrestaSlot s'adapte à ton activité et tes besoins spécifiques, quelle que soit ta spécialité. Que tu sois débutant(e) ou expérimenté(e).",
        hairdressing: {
            title: "Coiffeur/se",
            description: "Gère facilement tes rendez-vous et fidélise ta clientèle avec des rappels personnalisés"
        },
        aesthetics: {
            title: "Esthéticien(ne)",
            description: "Optimise ton planning et propose des réservations en ligne 24h/24"
        },
        nails: {
            title: "Prothésiste ongulaire",
            description: "Organise ton agenda et permets à tes clients de choisir leur prestation en ligne"
        },
        makeup: {
            title: "Maquilleur(se)",
            description: "Gère tes réservations pour événements et séances individuelles sans stress"
        },
        cta: {
            text: "Joins toi à nous !",
        }
    },
    pricing: {
        title: "Tarification simple et transparente",
        subtitle: "Essai gratuit de 14 jours, sans engagement",
        essential: {
            title: "Essentiel",
            price: "19€",
            period: "/mois",
            features: [
                "Jusqu'à 50 réservations/mois",
                "Gestion de calendrier",
                "Paiements en ligne",
                "Support par email"
            ],
            button: "Commencer l'essai"
        },
        professional: {
            title: "Professionnel",
            price: "39€",
            period: "/mois",
            popular: "Populaire",
            features: [
                "Réservations illimitées",
                "Statistiques avancées",
                "Personnalisation",
                "Support prioritaire"
            ],
            button: "Commencer l'essai"
        },
        enterprise: {
            title: "Entreprise",
            price: "89€",
            period: "/mois",
            features: [
                "Multi-utilisateurs",
                "API dédiée",
                "Intégrations avancées",
                "Support dédié"
            ],
            button: "Nous contacter"
        }
    },
    launch: {
        title: "Lancement Exclusif",
        subtitle: "Sois parmi les premiers à transformer ton activité",
        freeAccess: "1 mois gratuit",
        description: "Pour célébrer notre lancement, nous offrons un accès entièrement gratuit à toutes les fonctionnalités premium de PrestaSlot. Simplifie la gestion de tes rendez-vous, boostez ta visibilité et développe ta activité dès maintenant.",
        cta: "Commencer gratuitement",
        footer: "Aucune carte de crédit requise • Accès complet • Sans engagement",
    }
}

export const errors = {
    emptyFields: "Veuillez remplir tous les champs.",
    incorrectPassword: "Mot de passe incorrect.",
    passwordsDontMatch: "Les mots de passe ne correspondent pas.",
    termsNotAccepted: "Vous devez accepter les conditions d'utilisation."
}

export const emailVerification = {
    title: "Vérification de votre email en cours...",
    success: "Email vérifié avec succès!",
    adress: "Votre adresse email",
    suite: "a été vérifiée avec succès.",
    connect: "Vous pouvez maintenant vous connecter à votre compte.",
    login: "Se connecter",
    alreadyVerified: "Email déjà vérifié",
    suite1: "a déjà été vérifiée.",
    connect1: "Vous pouvez vous connecter à votre compte.",
    expired: "Lien expiré",
    expired1: "Le lien de vérification a expiré.",
    resend: "Demander un nouveau lien",
    backToLogin: "Retour à la connexion",
    error: "Erreur",
    error1: "Une erreur est survenue lors de la vérification de votre email.",
}

export const forgotPassword = {
  emailSentTitle: "Email envoyé",
  emailSentText: "Si cette adresse email est associée à un compte, vous recevrez un lien pour réinitialiser votre mot de passe. Veuillez vérifier votre boîte de réception.",
  backToLogin: "Retour à la connexion",
  forgotPasswordTitle: "Mot de passe oublié",
  forgotPasswordText: "Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
  sendingLink: "Envoi en cours...",
  sendLink: "Envoyer le lien de réinitialisation"
}

export const resetPassword = {
  successTitle: "Mot de passe réinitialisé",
  successText: "Votre mot de passe a été réinitialisé avec succès.",
  connectText: "Vous pouvez maintenant vous connecter à votre compte.",
  connectButton: "Se connecter maintenant",
  forgotPasswordTitle: "Mot de passe oublié",
  forgotPasswordText: "Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
  tokenMissing: "Token manquant. Veuillez utiliser le lien envoyé par email.",
  resettingPassword: "Réinitialisation en cours...",
  resetPassword: "Réinitialiser le mot de passe",
  backToLogin: "Retour à la connexion",
  verifying: "Vérification du lien...",
  alreadyUsedTitle: "Lien déjà utilisé",
  alreadyUsedText: "Ce lien de réinitialisation a déjà été utilisé ou n'est plus valide. Pour des raisons de sécurité, chaque lien ne peut être utilisé qu'une seule fois.",
  expiredTitle: "Lien expiré",
  expiredText: "Ce lien de réinitialisation a expiré. Les liens de réinitialisation sont valables pendant 1 heure.",
  requestNewLink: "Demander un nouveau lien"
}

export const footer = {
    product: "Produit",
    resources: "Ressources",
    info: "Informations",
    documentation: "Documentation",
    tutorials: "Tutoriels",
    about: "À propos",
    legal: "Mentions légales",
    contactUs: "Contactez-nous",
    allRightsReserved: "Tous droits réservés.",
    terms: "Conditions Générales",
    privacy: "Politique de Confidentialité"
}

export const sidebar = {
    principal: "Principal",
    dashboard: "Tableau de bord",
    calendar: "Calendrier",
    reservations: "Réservations",
    gestion: "Gestion",
    services: "Prestations",
    availability: "Disponibilités",
    parametres: "Paramètres",
    profile: "Profil",
    dark: "Sombre",
    logout: "Déconnexion",
    profession: "Profession ?",
    billing: "Facturation",
    guide_utilisation: "Utilisation",
    guide: "Guide",
    reviews: "Avis",
    stripeConnect: "Solde"
}

export const logoutConfirmationModal = {
    title: "Confirmation de déconnexion",
    description: "Êtes-vous sûr de vouloir vous déconnecter ?",
    cancel: "Annuler",
    logout: "Déconnexion"
}

export const availability = {
    title: "Disponibilités",
    addSlot: "Ajouter un créneau",
    endTimeBeforeStartTime: 'L\'heure de fin doit être après l\'heure de début',
    recurringSlots: "Créneaux récurrents",
    textOptionDrawer: "Veuillez choisir le type de créneaux",
    recurringSlotsDescription: "Définissez vos créneaux hebdomadaires et leur période d'application",
    startDate: "Date de début",
    endDate: "Date de fin",
    startTime: "Heure de début",
    endTime: "Heure de fin",
    oneTimeSlots: "Créneaux ponctuels",
    oneTimeSlotsDescription: "Ajoutez des créneaux pour des dates spécifiques",
    date: "Date",
    noOneTimeSlotAdded: "Aucun créneau ponctuel ajouté",
    validate: "Valider",
    dayNames: {
        lun: "Lun",
        mar: "Mar",
        mer: "Mer",
        jeu: "Jeu",
        ven: "Ven",
        sam: "Sam",
        dim: "Dim"
    },
    editSlot: "Modifier le créneau",
    deleteSlot: "Supprimer le créneau",
    confirmDelete: "Confirmer la suppression",
    confirmDeleteMessage: "Êtes-vous sûr de vouloir supprimer ce créneau ? Cette action est irréversible.",
    confirmDeleteTitle: "Confirmer la suppression",
    confirmDeleteConfirmText: "Supprimer",
    confirmDeleteCancelText: "Annuler",
    editSlot1: "Modifier un créneau récurrent",
    editSlot2: "Modifier un créneau",
    date_select: "Sélectionner une date",
    save: "Enregistrer",
    shareLink: "Partager votre lien de réservation",
    copied: "Copié!",
    sharelink: "Copier le lien",
    unavailable: "Indisponible",
    timeZone: "Fuseau horaire",
    selectSlotType: "Veuillez choisir un type de créneau",
    selectSlotTypeDescription: "Sélectionnez \"Ponctuel\" ou \"Récurrent\" pour continuer",
    add: "Ajouter",
    period: "Période d'application des créneaux récurrents",
    fullYear: "Année complète",
    fullYearDescription: "Ces créneaux hebdomadaires s'appliqueront du 1er janvier au 31 décembre",
    customPeriod: "Période personnalisée",
    customPeriodDescription: "Définir des dates de début et de fin spécifiques pour ces créneaux hebdomadaires",
    debutDate: "Date de début",
    finDate: "Date de fin",
    validation: "Valider"
}

export const services = {
    placeholder: "Rechercher une prestation...",
    title: "Prestations",
    titleList: "Liste des prestations",
    subtitle: "Gérez vos services, catégories d'options et options",
    add: "Nouvelle prestation",
    retry: "Réessayer",
    serviceName: "Nom",
    serviceDescription: "Description",
    price: "Prix (€)",
    duration: "Durée",
    noServicesFound: "Aucune prestation trouvée",
    noServices: "Aucun service trouvé",
    addService: "Ajouter une prestation",
    editService: "Modifier la prestation",
    viewService: "Détails de la prestation",
    category_temporary: "Catégorie temporaire",
    optional: "Optionnel",
    deleteOption: "Supprimer l'option",
    deleteCategory: "Supprimer la catégorie",
    reactivateService: "Réactiver la prestation",
    addOption: "Ajouter une option",
    editOption: "Modifier l'option",
    viewOption: "Détails de l'option",
    optionName: "Nom",
    optionNamePlaceholder: "Nom de l'option",
    optionDescription: "Description (optionnelle)",
    optionDescriptionPlaceholder: "Description de l'option",
    optionPrice: "Prix supplémentaire (€)",
    optionImage: "Image (optionnelle)",
    optionImagePlaceholder: "Aucune image",
    optionActive: "Option active",
    browse: "Parcourir",
    close: "Fermer",
    cancel: "Annuler",
    create: "Créer",
    save: "Enregistrer",
    loading: "Chargement...",
    addCategory: "Ajouter une catégorie d'option",
    editCategory: "Modifier la catégorie d'option",
    categoryName: "Nom",
    categoryNamePlaceholder: "Nom de la catégorie",
    categoryDescription: "Description (optionnelle)",
    categoryDescriptionPlaceholder: "Description de la catégorie",
    categoryPrice: "Prix supplémentaire (€)",
    categoryImage: "Image (optionnelle)",
    categoryImagePlaceholder: "Aucune image",
    categoryIsActive: "Catégorie active",
    categoryIsRequired: "Option requise",
    categoryOptional: "Optionnelle",
    categoryIsMultipleChoice: "Choix multiple autorisé",
    multipleChoice: "Choix multiple autorisé",
    singleChoice: "Choix unique autorisé",
    errorSubmittingService: "Une erreur est survenue lors de la soumission du service",
    imageTooLarge: "L'image est trop volumineuse. Taille maximale: 2MB. Taille actuelle: {{size}}MB",
    serviceImagePlaceholder: "Glissez une image ou cliquez pour parcourir",
    requiresBooking: "Nécessite une réservation",
    isActive: "Service actif",
    reactivate: "Réactiver",
    bookings: "réservations",
    withoutBooking: "Sans réservation",
    optionCategories: "Catégories d'option",
    categoryInactive: "Inactif",
    optionInactive: "Inactif",
    noCategories: "Aucune catégorie d'option pour ce service",
    update: "Modifier",
    delete: "Supprimer",
    // Nouveaux champs pour les paramètres de réservation
    bookingSettings: "Paramètres de réservation",
    minTimeBeforeBooking: "Délai minimum avant réservation",
    minTimeBeforeBookingHelp: "Délai minimum avant qu'un client puisse réserver (en minutes)",
    bufferTimeBetweenSlots: "Temps tampon entre rendez-vous",
    bufferTimeBetweenSlotsHelp: "Temps automatiquement ajouté entre deux rendez-vous (en minutes)",
    noMinTimeSet: "Aucun délai minimum défini",
    noBufferTimeSet: "Aucun temps tampon défini",
    
    activate: "Activer",
    deactivate: "Désactiver",
    deleteTitle: "Supprimer le service",
    deleteMessage: "Êtes-vous sûr de vouloir supprimer le service \"${service.name}\" ? Cette action est irréversible.",
    deleteConfirmText: "Supprimer",
    deleteCancelText: "Annuler",
    activateConfirmText: "Activer",
    activateCancelText: "Annuler",
    deactivateConfirmText: "Désactiver",
    deactivateCancelText: "Annuler",
    statusFilter: {
        all: "Tous",
        active: "Actif",
        inactive: "Inactif"
    },
    noImage: "Pas d'image",
    noDescription: "Pas de description",
    noBookingRequired: "Sans réservation",
    view: "Voir",
    edit: "Modifier",
    confirmDelete: "Confirmer la suppression",
    deleteConfirmation: "Êtes-vous sûr de vouloir supprimer ce service ?",
    noOptions: "Aucune option dans cette catégorie",
    free: "Gratuit",
    serviceImage: "Image",
    addOptionCategoryQuestion: "Souhaitez-vous créer une catégorie d'options pour ce service ?",
    categoryWithoutOptionsWarning: "Les catégories sans options seront automatiquement supprimées à la fermeture de cette fenêtre.",
    createCategory: "Création...",
    saveCategory: "Enregistrement...",
    required: "Requis",
    saving: "Enregistrement...",
    // Collaborateurs
    assignCollaborators: "Assigner des collaborateurs",
    assignCollaboratorsHelp: "Sélectionnez les collaborateurs qui peuvent effectuer cette prestation",
    assignedCollaborators: "Collaborateurs assignés",
    noCollaboratorsAvailable: "Aucun collaborateur disponible",
    viewCollaborators: "Voir les collaborateurs",
    noneCollaboratorsAssigned: "Aucun collaborateur disponible"
}

export const profile = {
    title: "Profil",
    subtitle: "Gérez vos préférences et informations",
    edit: "Modifier",
    personal: "Profil personnel",
    business: "Profil professionnel",
    security: "Sécurité",
    subscription: "Abonnement",
    language: "Langue",
    languageSettings: "Paramètres de langue",
    languageDescription: "Gérez les paramètres de langue de l'application",
    languageChoice: "Langue de l'application",
    languageFR: "Français",
    languageEN: "English",
    updatePreferences: "Mise à jour...",
    savePreferences: "Enregistrer les préférences",
    subscriptionDescription: "Informations sur votre abonnement",
    subscriptionFree: "Application gratuite",
    subscriptionFreeDescription: "Pour le lancement de Presta Slot, l'application est entièrement gratuite jusqu'à nouvel ordre. Profitez de toutes les fonctionnalités sans aucune restriction ni engagement.",
    subscriptionFreeDescription2: "Nous vous informerons à l'avance lorsque les plans payants seront disponibles.",
    securityDescription: "Gérez vos informations de sécurité",
    changePassword: "Changer votre mot de passe",
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    confirmNewPassword: "Confirmer le nouveau mot de passe",
    updatePassword: "Mettre à jour le mot de passe",
    newPasswordDescription: "8 caractères minimum, avec lettres et chiffres",
    businessDescription: "Gérez les informations de votre entreprise",
    businessName: "Nom de l'entreprise",
    businessDescriptionVisible: "Visible sur votre page de réservation publique",
    businessAddress: "Adresse",
    businessPostalCode: "Code postal",
    businessCity: "Ville",
    businessCountry: "Pays",
    businessPhone: "Téléphone",
    businessEmail: "Email",
    businessSiren: "SIREN",
    verified: "Vérifié",
    sirenDescription: "Numéro SIREN à 9 chiffres pour vérifier votre entreprise",
    businessLogo: "Logo",
    changeLogo: "Changer le logo",
    logoFormat: "PNG, JPG ou SVG. 2MB maximum.",
    updateBusiness: "Mettre à jour le profil professionnel",
    personalDescription: "Gérez vos informations personnelles",
    firstName: "Prénom",
    lastName: "Nom",
    phone: "Téléphone",
    email: "Email",
    profession: "Profession",
    timeZone: "Fuseau horaire",
    updatePersonal: "Enregistrer les changements",
    professionPlaceholder: "Ex: Coiffeur",
    passwordChangeSuccess: "Votre mot de passe a été modifié avec succès. Vous serez déconnecté dans quelques secondes...",
    redirecting: "Redirection...",
    businessReservationConditions: "Conditions de réservation",
    businessReservationConditionsVisible: "Visible sur votre page de réservation publique",
    businessReservationConditionsPlaceholder: "Décrivez vos conditions de réservation...",
    businessPaymentMethods: "Moyens de paiement acceptés",
    businessPaymentMethodsDescription: "Ces informations seront affichées aux clients lors de la réservation et dans les emails de rappel",
    paymentMethodCash: "Espèces",
    paymentMethodCreditCard: "Carte bancaire",
    paymentMethodBankTransfer: "Virement bancaire",
    paymentMethodCheck: "Chèque",
    paymentMethodPaypal: "PayPal",
    paymentMethodMobilePayment: "Paiement mobile",
    paymentMethod: "Moyen de paiement",

    // Gallery photos
    galleryPhotos: "Photos du salon",
    mainPhoto: "Photo principale",
    replacePhoto: "Remplacer la photo",
    deletePhoto: "Supprimer la photo",
    uploadPhotos: "Ajouter des photos",
    selectedPhotos: "Photos sélectionnées",
    uploading: "Envoi en cours...",
    photoFormat: "PNG, JPG ou WebP. 2MB maximum.",
    addPhotos: "Ajouter des photos",
    galleryPhotoInfo: "La première photo sera affichée comme photo principale dans votre galerie.",
    maxPhotos: "Maximum 5 photos.",
}

export const emailVerificationBanner = {
    title: "Vérifiez votre boîte mail",
    description: "Cliquez sur le lien dans l'email pour activer votre compte"
}

export const calendar = {
    title: "Calendrier",
    newAppointment: "Nouveau rendez-vous",
    cancelAppointment: "Annuler le rendez-vous",
    appointmentDetails: "Détails du rendez-vous",
    cancelAppointmentDescription: "Cette action est irréversible. Le client sera notifié de l'annulation.",
    return: "Retour",
    confirmCancellation: "Confirmer l'annulation",
    options: "Options",
    confirmed: "Confirmé",
    cancelled: "Annulé",
    completed: "Terminé",
    date: "Date",
    time: "Heure",
    clientName: "Nom du client",
    clientEmail: "Email",
    clientPhone: "Téléphone",
    close: "Fermer",
    week1: "Semaine du",
    week: "Semaine",
    day: "Jour",
    day2: "Aujourd'hui",
    week2: "Cette semaine",
    booked: "Réservé"
}

export const reservations = {
    title: "Réservations",
    subtitle: "Gérez vos rendez-vous avec vos clients",
    loadingDetails: "Chargement des détails...",
    confirmed: "Confirmé",
    cancelled: "Annulé",
    completed: "Terminé",
    dateUnavailable: "Date non disponible",
    timeUnavailable: "Horaires non disponibles",
    phoneNotSpecified: "Téléphone non renseigné",
    notSpecified: "Non renseigné",
    clientNotSpecified: "Client non spécifié",
    emailNotSpecified: "Email non renseigné",
    appointmentInfo: "Informations rendez-vous",
    reservationDetails: "Détails de la réservation",
    serviceNotSpecified: "Service non spécifié",
    options: "Options sélectionnées",
    cancellationReason: "Raison d'annulation",
    specialInstructions: "Instructions spéciales",
    reservationCancelled: "Cette réservation a été annulée",
    close: "Fermer",
    total: "Total",
    currency: "€",
    dateUnknown: "Date inconnue",
    timeUnknown: "Heure inconnue",
    noReservationsFound: "Aucune réservation trouvée",
    actions: "Actions",
    status: "Statut",
    date: "Date",
    time: "Heure",
    clientName: "Nom du client",
    service: "Service",
    duration: "Durée",
    price: "Prix",
    search: "Rechercher...",
    day: "Jour",
    week: "Semaine",
    month: "1 Mois",
    all: "Toutes",
    totalBookings: "Total réservations",
    confirmationRate: "Taux de confirmation",
    totalValue: "Valeur totale",
    clientInfo: "Informations client"
}

export const dashboard = {
    title: "Tableau de bord",
    appointmentsOfDay: "Rendez-vous du jour",
    all: "Tous",
    quickActions: "Actions rapides",
    ongoing: "En cours",
    upcoming: "À venir",
    past: "Passés",
    appointments: "rendez-vous",
    greeting: "Bonjour",
    activity: "voici l'activité du",
    noAppointments: "Aucun rendez-vous",
    newAppointment: "Nouveau RDV",
    availability: "Disponibilités",
    revenue: "Recettes du jour",
    revenueTotal: "Total des recettes",
    revenueCompleted: "Terminés",
    revenueUpcoming: "À venir",
    currency: "€",
    close: "Fermer",
    newAppointment1: "Nouveau rendez-vous",
    requiredFields: "Les champs marqués d'un",
    requiredFields2: "sont obligatoires.",
    loadingServices: "Chargement des services...",
    selectService: "Sélectionner un service",
    options: "Options",
    serviceNoBooking: "Ce service ne nécessite pas de réservation de créneau horaire.",
    serviceNoBooking2: "Vous pouvez directement confirmer votre commande. Le prestataire vous contactera prochainement.",
    serviceNoBooking3: "Veuillez sélectionner un service pour continuer",
    serviceNoBooking4: "Veuillez sélectionner une date pour voir les horaires disponibles",
    cancel: "Annuler",
    confirm: "Confirmer",
    loading: "Chargement...",
    loading1: "Chargement des horaires...",
    noSlots: "Aucun créneau disponible pour cette date. Veuillez choisir une autre date ou un autre service.",
    availableSlots: "Horaires disponibles",
    selectOption: "Sélectionner une option",
    cancelAppointment: "Marquer comme annulé",
    next: "Prochain",
    activityHowMany: "Il y a",
    phone: "Téléphone",
    email: "Email",
    firstName: "Prénom",
    lastName: "Nom"
}

export const booking = {
    bookService: "Réserver une prestation",
    selectService: "Sélectionnez un service",
    selectOptions: "Choisissez vos options",
    selectDateTime: "Choisissez une date et un horaire",
    yourInformation: "Vos informations",
    confirm: "Confirmer la réservation",
    bookingSuccess: "Réservation confirmée !",
    bookingError: "Erreur lors de la réservation",
    noServices: "Aucune prestation disponible",
    serviceOptions: "Options de service",
    totalPrice: "Prix total",
    confirmBooking: "Confirmer la réservation",
    loading: "Chargement des prestations...",
    bookingDescription: "Choisissez un service, personnalisez vos options et réservez votre créneau en quelques clics.",
    includingOptions: "Options incluses",
    confirmationNote: "En confirmant, vous acceptez nos conditions générales de service.",
    servicesCount: "{{count}} services disponibles",
    howItWorks: "Comment ça marche ?",
    step1: "1. Choisissez",
    step1Desc: "Sélectionnez la prestation qui vous intéresse",
    step2: "2. Personnalisez",
    step2Desc: "Ajoutez des options et renseignez vos informations personnelles si nécessaire",
    step3: "3. Planifiez",
    step3Desc: "Choisissez une date et un créneau horaire disponible",
    step4: "4. Confirmez",
    step4Desc: "Validez votre réservation et recevez une confirmation par email",
    bookingConfirmed: "Réservation confirmée",
    confirmationEmailSent: "Un email de confirmation vous a été envoyé",
    bookingDetails: "Détails de la réservation",
    service: "Service",
    date: "Date",
    time: "Heure",
    thankYou: "Merci pour votre confiance. À bientôt pour votre prestation !",
    options: "Options disponibles",
    multipleChoice: "Choix multiple",
    selectDate: "Sélectionnez une date",
    clientInfo: "Vos informations",
    firstName: "Prénom",
    lastName: "Nom",
    email: "Email",
    phone: "Téléphone",
    requiredFields: "Les champs marqués d'un * sont obligatoires",
    privacyNote: "Vos informations personnelles ne seront utilisées que pour traiter votre réservation et vous contacter en cas de besoin.",
    importantInfo: "Information importante",
    importantInfoText: "Le paiement n'est pas géré par notre plateforme. Veuillez contacter directement votre prestataire pour organiser le paiement de votre réservation.",
    reservationConditionsTitle: "Conditions de réservation !",
}

export const bookingCancellation = {
    backToHome: "Retour à l'accueil",
    errorTitle: "Erreur",
    cancelled: "Réservation annulée",
    details: "Détails de la réservation",
    client: "Client",
    date: "Date",
    service: "Service",
    options: "Options sélectionnées",
    totalPaid: "Montant payé",
    paidDeposit: "Acompte versé",
    canceling: "Annulation en cours...",
    cancelBooking: "Annuler la réservation",
    cancelledDone: "Votre réservation a bien été annulée"
}

export const faq = {
    title: "Foire aux questions",
    subtitle: "Trouve rapidement des réponses à tes questions",
    categories: {
        client: "Pour les clients",
        professional: "Pour les professionnels"
    },
    client: {
        booking: {
            question: "Comment réserver un créneau sur PrestaSlot ?",
            answer: "Pour réserver un créneau, sélectionne d'abord le service souhaité, puis choisis un créneau disponible dans le calendrier. Complète ensuite le formulaire avec tes coordonnées et confirme la réservation."
        },
        account: {
            question: "Dois-je créer un compte pour réserver ?",
            answer: "Non, tu n'as pas besoin de créer de compte pour effectuer une réservation. Il te suffit de fournir tes coordonnées lors de la prise de rendez-vous."
        },
        cancel: {
            question: "Comment annuler ou modifier une réservation ?",
            answer: "Tu peux annuler ta réservation en utilisant le lien fourni dans l'email de confirmation. Pour toute modification, contacte directement le professionnel."
        },
        payment: {
            question: "Quels sont les modes de paiement acceptés ?",
            answer: "Les modes de paiement varient selon les professionnels. Les détails des moyens de paiement acceptés sont à confirmer avec le professionnel. PrestaSlot ne prend pas en charge les transactions financières entre professionnels et clients."
        },
        contact: {
            question: "Comment contacter un professionnel après ma réservation ?",
            answer: "Tu peux contacter le professionnel via les coordonnées fournies dans l'email de confirmation de ta réservation."
        }
    },
    professional: {
        start: {
            question: "Comment commencer à utiliser PrestaSlot ?",
            answer: "Inscris-toi gratuitement, configure ton profil et tes services, puis ajoute tes disponibilités. Tu pourras ensuite partager ton lien de réservation avec tes clients."
        },
        trial: {
            question: "Combien de temps dure la période d'essai gratuit ?",
            answer: "Tu bénéficies d'un mois d'essai gratuit avec accès à toutes les fonctionnalités premium. Aucune carte bancaire n'est requise pour commencer."
        },
        calendar: {
            question: "Puis-je synchroniser mon calendrier existant ?",
            answer: "Oui, PrestaSlot se synchronise avec Google Calendar, Apple Calendar et Outlook. Tu peux configurer cette synchronisation dans les paramètres de ton compte."
        },
        notifications: {
            question: "Comment fonctionnent les rappels automatiques ?",
            answer: "Les rappels sont envoyés automatiquement par email et/ou SMS selon tes préférences. Tu peux personnaliser le moment d'envoi (24h, 12h ou 1h avant le rendez-vous)."
        },
        pricing: {
            question: "Quels sont les tarifs après la période d'essai ?",
            answer: "Après la période d'essai, tu peux choisir entre différentes formules selon tes besoins. Consulte notre page Tarifs pour plus de détails."
        }
    },
    cta: {
        text: "Tu as d'autres questions ?",
        button: "Contacte-nous"
    }
}

export const terms = {
    title: "Conditions Générales d'Utilisation",
    sections: {
      legal: {
        title: "Mentions Légales",
        editor: {
          title: "Éditeur du site",
          content: [
            "PrestaSlot est édité par :",
            "Raison sociale : Indemba Emmanuel",
            "Représentant légal : Indemba Emmanuel",
            "Forme juridique : Entreprise Individuel",
            "SIREN : 903843555",
            "Numéro de TVA intracommunautaire : FR49903843555",
            "Service support : contact-pro@prestaslot.com"
          ]
        },
        hosting: {
          title: "Hébergement",
          content: [
            "PrestaSlot est hébergé par :",
            "Vercel Inc.",
            "Société de droit américain (Inc.)",
            "340 S Lemon Ave #4133, Walnut, CA 91789, USA",
            "Téléphone : (559) 288-7060",
            "E-mail : privacy@vercel.com"
          ]
        }
      },
      intro: {
        title: "1. Introduction",
        content:
          "Bienvenue sur PrestaSlot. Les présentes Conditions Générales d'Utilisation régissent votre utilisation de notre plateforme et de tous les services associés. En utilisant notre service, vous acceptez d'être lié par ces conditions."
      },
      serviceDescription: {
        title: "2. Description du Service",
        content: [
          "PrestaSlot est une plateforme SaaS (Software as a Service) de réservation en ligne qui permet aux prestataires de services de gérer leurs disponibilités, de recevoir des paiements en ligne et aux clients de réserver des créneaux horaires pour différents services avec ou sans paiement préalable.",
          "PrestaSlot fournit une infrastructure technique permettant la mise en relation entre professionnels et clients, le traitement sécurisé des paiements via notre partenaire Stripe, la gestion de calendriers et l'envoi de notifications automatiques. Nous ne sommes pas responsables de la qualité des services fournis par les professionnels ni de l'exécution des prestations réservées."
        ]
      },
      usageTerms: {
        title: "3. Conditions d'Utilisation",
        content: [
          "Pour utiliser notre service, vous devez avoir au moins 18 ans ou avoir l'âge légal de la majorité dans votre juridiction. Les parents ou tuteurs légaux peuvent effectuer des réservations pour des mineurs sous leur responsabilité. Vous êtes responsable de maintenir la confidentialité de votre compte et de votre mot de passe.",
          "Les professionnels doivent fournir des informations exactes et à jour, notamment : nom, prénom, profession, email, numéro de téléphone, nom de l'entreprise, numéro SIREN (obligatoire pour la vérification de légitimité), description, adresse complète et fuseau horaire. Les clients doivent fournir au minimum leur prénom, nom et email (le numéro de téléphone étant optionnel).",
          "Les professionnels s'engagent à ne pas utiliser la plateforme à des fins illégales, frauduleuses ou contraires aux bonnes mœurs. PrestaSlot se réserve le droit de suspendre ou supprimer tout compte professionnel en cas de violation de ces conditions."
        ]
      },
      personalData: {
        title: "4. Données Personnelles",
        content: [
          "En utilisant notre service, vous acceptez que nous collections et utilisions vos données personnelles conformément à notre Politique de Confidentialité disponible sur notre site.",
          "Pour les clients, nous collectons : prénom, nom, email, numéro de téléphone (optionnel), historique de réservations et, en cas de paiement en ligne, un identifiant client Stripe (aucune donnée bancaire n'est stockée sur nos serveurs). Pour les professionnels, nous collectons des informations supplémentaires incluant le numéro SIREN, les identifiants Stripe pour les abonnements et paiements, ainsi que les préférences de configuration des services."
        ]
      },
      subscriptions: {
        title: "5. Abonnements Professionnels",
        content: [
          "PrestaSlot propose trois formules d'abonnement mensuel pour les professionnels : Junior (14,99€/mois), Premium (34,99€/mois) et Premium Plus (49,99€/mois). Chaque formule offre des fonctionnalités et limites différentes (nombre de salons, collaborateurs, accès aux paiements en ligne, système d'avis, etc.).",
          "Période d'essai : Tous les nouveaux professionnels bénéficient d'une période d'essai gratuite de 14 jours.",
          "Renouvellement et résiliation : Les abonnements sont à durée indéterminée avec renouvellement automatique mensuel. Vous pouvez annuler votre abonnement à tout moment depuis votre espace professionnel ou via le portail de facturation Stripe. L'annulation prendra effet à la fin de la période de facturation en cours, sans remboursement au prorata.",
          "Modification de formule : Vous pouvez à tout moment changer de formule (upgrade ou downgrade). En cas d'upgrade, la différence sera facturée au prorata. En cas de downgrade, le changement prendra effet à la prochaine période de facturation.",
          "Impayés : En cas de défaut de paiement, votre compte sera suspendu après 7 jours. Si le paiement n'est pas régularisé dans les 30 jours, votre compte sera définitivement supprimé et vos données seront archivées conformément à nos obligations légales."
        ]
      },
      payments: {
        title: "6. Paiements en Ligne et Facturation",
        content: [
          "Prestataire de paiement : PrestaSlot utilise Stripe comme unique prestataire de paiement sécurisé pour traiter toutes les transactions entre clients et professionnels. Stripe est certifié PCI-DSS niveau 1, le plus haut niveau de conformité en matière de sécurité des paiements. Aucune donnée bancaire (numéro de carte, CVV, etc.) n'est stockée sur les serveurs de PrestaSlot.",
          "Types de paiement : Les professionnels peuvent configurer trois modes de paiement pour leurs services : (1) Acompte - le client paie un pourcentage ou montant fixe défini par le professionnel (ex: 30% ou 15€), (2) Paiement intégral - le client paie le montant total du service lors de la réservation, (3) Sans paiement en ligne - la réservation est confirmée sans paiement préalable, le règlement s'effectuant directement avec le professionnel.",
          "Frais de service : Stripe applique des frais de service d'environ 1,5% + 0,25€ par paiement. Le professionnel peut choisir d'absorber ces frais (le client paie le prix du service tel qu'affiché) ou de les répercuter au client (montant légèrement supérieur facturé au client pour couvrir les frais de service). Ce choix est configurable dans les paramètres du compte professionnel.",
          "Stripe Connect : Les professionnels doivent créer un compte Stripe Connect pour recevoir les paiements de leurs clients. Le processus de vérification d'identité exigé par Stripe est obligatoire pour se conformer aux réglementations anti-blanchiment. Les fonds sont transférés sur le compte bancaire du professionnel selon les délais définis par Stripe (généralement sous 2 à 7 jours ouvrés).",
          "Remboursements : En cas d'annulation d'une réservation avec paiement, le remboursement est soumis aux conditions définies par le professionnel. Si le service prévoit un remboursement automatique en cas d'annulation avant un certain délai (ex: 24h avant), le remboursement sera effectué automatiquement via Stripe. Le montant remboursé correspondra au montant net reçu par le professionnel (après déduction des frais de service). Les frais de service ne sont jamais remboursés par Stripe lors d'un remboursement.",
          "Facturation des abonnements : Les factures d'abonnement professionnel sont générées automatiquement par Stripe et envoyées par email. Vous pouvez accéder à l'historique complet de vos factures via le portail de facturation Stripe accessible depuis votre espace professionnel.",
          "Codes promo : Les professionnels peuvent créer des codes promotionnels offrant des réductions (en pourcentage ou montant fixe) sur leurs services. Les codes peuvent être limités à certains clients ou services spécifiques, avec des dates de validité définies. Chaque client ne peut utiliser un code promo qu'une seule fois."
        ]
      },
      accountManagement: {
        title: "7. Gestion des Comptes",
        content: [
          "Comptes clients : Les clients n'ont pas besoin de créer de compte pour effectuer une réservation. Ils fournissent simplement leurs coordonnées (prénom, nom, email, téléphone optionnel) lors de chaque réservation. Un identifiant unique est créé automatiquement pour assurer le suivi des réservations et paiements.",
          "Comptes professionnels : Les professionnels disposent d'un compte sécurisé par mot de passe pour gérer leurs services, disponibilités, réservations et paramètres d'abonnement. Le mot de passe est stocké sous forme hachée (bcrypt) et n'est jamais accessible en clair, même par nos équipes.",
          "Suppression de compte professionnel : Pour supprimer votre compte professionnel, contactez notre service client via le chatBot ou à l'adresse contact-pro@prestaslot.com. La suppression entraînera : (1) l'annulation immédiate de votre abonnement sans remboursement, (2) la désactivation de vos services et disponibilités, (3) l'archivage de vos données de réservations et paiements pour la durée légale obligatoire (5 à 10 ans pour les données fiscales), (4) la suppression définitive de vos données personnelles après cette période. Important : certaines données sont conservées pour se conformer aux obligations légales et comptables.",
          "Annulation de réservation : Les clients peuvent annuler leurs réservations via le lien sécurisé reçu par email lors de la confirmation. Selon la politique d'annulation définie par le professionnel, un remboursement automatique peut être effectué. Les professionnels peuvent également annuler des réservations depuis leur espace, auquel cas le client est automatiquement notifié et remboursé si un paiement avait été effectué."
        ]
      },
      intellectualProperty: {
        title: "8. Propriété Intellectuelle",
        content: [
          "Contenu de la plateforme : Tous les éléments de la plateforme PrestaSlot (design, code source, logo, textes, graphiques, interface utilisateur) sont la propriété exclusive de PrestaSlot ou de ses partenaires et sont protégés par les lois françaises et internationales sur la propriété intellectuelle. Toute reproduction, distribution ou utilisation non autorisée est strictement interdite.",
          "Contenu créé par les professionnels : Les professionnels conservent tous les droits de propriété intellectuelle sur le contenu qu'ils créent et publient sur la plateforme (descriptions de services, photos, logos d'entreprise, etc.). En publiant ce contenu, vous accordez à PrestaSlot une licence mondiale, non-exclusive, transférable et gratuite d'utiliser, reproduire, afficher et distribuer ce contenu uniquement dans le cadre de la fourniture et de la promotion de nos services.",
          "Avis clients : Les avis et commentaires publiés par les clients appartiennent à leurs auteurs. En publiant un avis, vous accordez à PrestaSlot le droit de l'afficher publiquement sur la plateforme et de l'utiliser à des fins promotionnelles. PrestaSlot se réserve le droit de modérer ou supprimer tout contenu inapproprié, diffamatoire ou contraire à nos conditions d'utilisation."
        ]
      },
      responsibility: {
        title: "9. Responsabilité des Professionnels",
        content: [
          "Chaque professionnel est seul responsable des services qu'il propose, de leur description exacte, de leur disponibilité, de leur exécution conforme et de leur conformité aux lois et réglementations en vigueur. Le professionnel garantit qu'il dispose de toutes les autorisations légales, licences, assurances professionnelles et qualifications nécessaires à l'exercice de son activité.",
          "Le professionnel s'engage à fournir un numéro SIREN valide et à maintenir à jour ses informations légales. PrestaSlot se réserve le droit de vérifier la validité du SIREN via les services officiels (INPI, INSEE) et de suspendre tout compte dont les informations seraient frauduleuses ou non vérifiables.",
          "Le professionnel est responsable de la gestion de son calendrier, de ses disponibilités et de la confirmation de ses rendez-vous. En cas de non-présentation ou d'annulation de dernière minute de la part du professionnel, celui-ci devra gérer directement avec le client les éventuels dédommagements."
        ]
      },
      liability: {
        title: "10. Limitation de Responsabilité",
        content: [
          "Rôle d'intermédiaire : PrestaSlot agit uniquement en tant que plateforme technique mettant en relation professionnels et clients. Nous ne pouvons être tenus responsables de la qualité, de la sécurité, de la légalité ou de tout autre aspect des services fournis par les professionnels, ni des litiges, réclamations, dommages ou préjudices résultant directement ou indirectement de ces prestations.",
          "Disponibilité du service : Nous nous efforçons de maintenir la plateforme accessible 24h/24 et 7j/7, mais ne pouvons garantir une disponibilité ininterrompue. Des interruptions peuvent survenir pour maintenance, mises à jour ou en cas de force majeure. PrestaSlot ne saurait être tenu responsable des pertes financières ou autres préjudices résultant d'une indisponibilité temporaire du service.",
          "Paiements et transactions : PrestaSlot ne peut être tenu responsable des dysfonctionnements, retards ou erreurs liés au service de paiement Stripe. En cas de litige relatif à un paiement, le client ou le professionnel devra contacter directement Stripe ou sa banque. Notre responsabilité se limite à fournir l'infrastructure technique permettant la connexion à Stripe.",
          "Limitation de garantie : La plateforme est fournie \"en l'état\" sans garantie d'aucune sorte, explicite ou implicite. Nous ne garantissons pas que le service sera exempt d'erreurs, de virus ou d'autres éléments nuisibles. La responsabilité de PrestaSlot est limitée au montant des frais d'abonnement payés par le professionnel au cours des 12 derniers mois."
        ]
      },
      reporting: {
        title: "11. Signalement et Modération",
        content: [
          "Si vous rencontrez un problème avec un professionnel (non-respect des engagements, comportement inapproprié, fraude suspectée, etc.), veuillez nous le signaler immédiatement via le chatBot disponible sur notre plateforme ou par email à contact-pro@prestaslot.com. Toute réclamation sera examinée dans les meilleurs délais.",
          "PrestaSlot se réserve le droit de suspendre ou supprimer définitivement tout compte professionnel faisant l'objet de plaintes récurrentes ou de comportements frauduleux, sans préavis ni remboursement de l'abonnement en cours. En cas de suppression pour faute grave, les fonds en attente de transfert pourront être bloqués le temps de l'enquête.",
          "Faux avis : La publication de faux avis (positifs ou négatifs) est strictement interdite. Nous nous réservons le droit de supprimer tout avis suspect et de sanctionner les comptes impliqués dans de telles pratiques."
        ]
      },
      changes: {
        title: "12. Modification des Conditions",
        content: [
          "PrestaSlot se réserve le droit de modifier ces Conditions Générales d'Utilisation à tout moment pour refléter les évolutions de notre service, de la législation ou pour toute autre raison légitime. Les utilisateurs seront informés des changements significatifs par email à l'adresse enregistrée dans leur compte et/ou par une notification sur la plateforme au moins 30 jours avant l'entrée en vigueur des modifications.",
          "La poursuite de l'utilisation de nos services après l'entrée en vigueur des nouvelles conditions vaut acceptation de celles-ci. Si vous n'acceptez pas les nouvelles conditions, vous pouvez résilier votre compte conformément aux dispositions prévues à l'article 7."
        ]
      },
      contact: {
        title: "13. Contact",
        content: [
          "Pour toute question concernant ces Conditions Générales d'Utilisation, vous pouvez nous contacter :",
          "• Via le chatBot disponible sur notre plateforme",
          "• Par email : contact-pro@prestaslot.com"
        ]
      },
      updatedAt: "Dernière mise à jour : 14 janvier 2026"
    }
  }

  export const privacy = {
    title: "Politique de Confidentialité",
    updatedAt: "Dernière mise à jour : 14 janvier 2026",
    sections: {
      introduction: {
        title: "1. Introduction",
        content: "Chez PrestaSlot, nous accordons une grande importance à la protection de vos données personnelles. Cette politique de confidentialité explique comment nous collectons, utilisons, partageons et protégeons vos informations lorsque vous utilisez notre plateforme de réservation en ligne. En utilisant PrestaSlot, vous acceptez les pratiques décrites dans cette politique."
      },
      responsable: {
        title: "2. Responsable du Traitement",
        content: [
          "Le responsable du traitement de vos données personnelles est :",
          "Indemba Emmanuel - PrestaSlot",
          "SIREN : 903843555",
          "Email : contact-pro@prestaslot.com",
          "Pour toute question relative à la protection de vos données personnelles, vous pouvez nous contacter aux coordonnées ci-dessus."
        ]
      },
      collectedData: {
        title: "3. Données Collectées",
        intro: "Selon votre statut (client ou professionnel), nous collectons différentes catégories de données personnelles :",
        clients: {
          title: "A. Pour les clients :",
          items: [
            "Données d'identification : Prénom, nom, adresse email",
            "Données de contact : Numéro de téléphone (optionnel)",
            "Données de réservation : Historique des réservations, services réservés, options choisies, notes ou commentaires",
            "Données de paiement : Identifiant client Stripe (stripeCustomerId), historique des transactions, montants payés, codes promo utilisés. Important : Aucune donnée bancaire (numéro de carte, CVV, date d'expiration) n'est stockée sur nos serveurs",
            "Données d'avis : Notes attribuées (1 à 5 étoiles), commentaires rédigés sur les services reçus",
            "Données techniques : Adresse IP, type de navigateur, système d'exploitation (via logs serveur)"
          ]
        },
        professionals: {
          title: "B. Pour les professionnels :",
          items: [
            "Données d'identification : Nom, prénom, adresse email, mot de passe (haché avec bcrypt)",
            "Données professionnelles : Numéro SIREN (obligatoire), nom d'entreprise, forme juridique, numéro de TVA intracommunautaire",
            "Coordonnées : Numéro de téléphone, adresse complète du lieu d'exercice (rue, ville, code postal, pays)",
            "Données bancaires et paiement : Identifiant client Stripe pour abonnement (stripeCustomerId), identifiant compte Stripe Connect pour recevoir les paiements (stripeConnectedAccountId), statut de vérification du compte Stripe, préférence d'absorption des frais de service",
            "Données d'abonnement : Plan souscrit (Junior/Premium/Premium Plus), statut de l'abonnement, date de début et de fin de période d'essai, historique de facturation",
            "Contenu créé : Descriptions des services, photos et images (logo entreprise, galerie, images de services), disponibilités et créneaux horaires, conditions de réservation et d'annulation, codes promo créés",
            "Préférences : Langue d'interface, fuseau horaire, paramètres de notification",
            "Données techniques : Adresse IP, type de navigateur, logs de connexion"
          ]
        },
        note: "Important : Les clients n'ont pas besoin de créer de compte pour effectuer une réservation. Un identifiant unique leur est automatiquement attribué lors de leur première réservation pour assurer le suivi. Aucune donnée bancaire (carte de crédit, IBAN, etc.) n'est jamais stockée sur les serveurs de PrestaSlot ; ces informations sont exclusivement traitées et sécurisées par notre partenaire Stripe, certifié PCI-DSS niveau 1."
      },
      purposes: {
        title: "4. Finalités du Traitement et Bases Légales",
        intro: "Nous utilisons vos données personnelles pour les finalités suivantes, sur les bases légales indiquées :",
        items: [
          "Gestion des réservations (Base légale : Exécution du contrat) : Permettre la prise de rendez-vous entre professionnels et clients, envoyer les confirmations de réservation par email, gérer les annulations et modifications",
          "Traitement des paiements (Base légale : Exécution du contrat) : Traiter les paiements en ligne via Stripe, gérer les acomptes et paiements intégraux, effectuer les remboursements en cas d'annulation, appliquer les codes promotionnels",
          "Gestion des abonnements professionnels (Base légale : Exécution du contrat) : Facturer les abonnements mensuels, gérer les périodes d'essai, permettre les changements de formule (upgrade/downgrade), suspendre ou résilier les comptes en cas d'impayé",
          "Communication avec les utilisateurs (Base légale : Exécution du contrat et intérêt légitime) : Envoyer les emails de confirmation de réservation, envoyer les rappels de rendez-vous (si activé par le professionnel), envoyer les demandes d'avis après prestation, envoyer les notifications d'annulation, communiquer les informations importantes sur le service",
          "Vérification de légitimité (Base légale : Obligation légale et intérêt légitime) : Vérifier la validité du numéro SIREN via les services officiels (INPI, INSEE), s'assurer que les professionnels exercent légalement leur activité, lutter contre la fraude et les usages abusifs",
          "Système d'avis clients (Base légale : Intérêt légitime) : Permettre aux clients de noter et commenter les services reçus, permettre aux professionnels de répondre aux avis, afficher publiquement les avis pour aider d'autres clients dans leur choix",
          "Amélioration et personnalisation du service (Base légale : Intérêt légitime) : Analyser l'utilisation de la plateforme pour améliorer l'expérience utilisateur, développer de nouvelles fonctionnalités, corriger les bugs et problèmes techniques, adapter l'interface selon les préférences linguistiques",
          "Respect des obligations légales (Base légale : Obligation légale) : Conserver les données de facturation et de paiement conformément aux obligations fiscales et comptables, répondre aux réquisitions judiciaires ou demandes des autorités compétentes, lutter contre le blanchiment d'argent et le financement du terrorisme (via la vérification Stripe)"
        ],
        note: "Important : Contrairement à ce qui était indiqué précédemment, PrestaSlot intervient désormais directement dans les transactions financières en fournissant l'infrastructure technique et en partenariat avec Stripe. Cependant, nous ne stockons jamais les données bancaires sensibles (numéros de carte, etc.)."
      },
      sharing: {
        title: "5. Partage et Communication des Données",
        intro: "Vos données personnelles peuvent être partagées avec les destinataires suivants :",
        items: [
          "A. Entre utilisateurs de la plateforme : Lorsqu'un client effectue une réservation, le professionnel concerné reçoit les informations du client (nom, prénom, email, téléphone si fourni, note éventuelle). Les clients accèdent aux informations publiques des professionnels (nom d'entreprise, adresse, services, avis clients, disponibilités).",
          "B. Stripe (prestataire de paiement) : Pour les paiements en ligne : Identifiants clients, emails, montants des transactions, métadonnées de réservation. Pour les abonnements professionnels : Emails, informations de facturation, plan souscrit. Pour Stripe Connect : Informations d'entreprise (SIREN, adresse, nom), données de vérification d'identité (exigées par Stripe pour conformité anti-blanchiment). Stripe est certifié PCI-DSS niveau 1 et conforme au RGPD (politique de confidentialité disponible sur stripe.com).",
          "C. Services d'envoi d'emails (Resend ou Nodemailer) : Emails destinataires, noms, contenus HTML des emails (confirmations, rappels, avis, réinitialisation de mot de passe). Ces prestataires agissent comme sous-traitants conformément au RGPD.",
          "D. AWS S3 (stockage de fichiers) : Images uploadées par les professionnels (logos, photos de services, galerie). Hébergement dans la région EU (eu-north-1) pour conformité RGPD. Les images sont optimisées et stockées en plusieurs tailles.",
          "E. INPI (Institut National de la Propriété Industrielle) : Numéros SIREN des professionnels, envoyés uniquement pour vérifier la légitimité de l'entreprise lors de l'inscription.",
          "F. Vercel (hébergement frontend) : Héberge le code de l'application cliente et les assets statiques. Aucune donnée personnelle n'est directement transmise, sauf logs de connexion standards (IP, user-agent).",
          "G. Autorités compétentes : En cas d'obligation légale, de réquisition judiciaire ou pour protéger nos droits, nous pouvons communiquer vos données aux autorités (police, justice, administration fiscale, CNIL)."
        ],
        note: "Important : Nous ne vendons JAMAIS vos données personnelles à des tiers à des fins commerciales. Nous ne partageons vos données qu'avec les prestataires strictement nécessaires au fonctionnement du service et qui s'engagent à respecter le RGPD."
      },
      security: {
        title: "6. Sécurité des Données",
        content: [
          "Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles strictes pour protéger vos données personnelles contre tout accès non autorisé, perte ou divulgation.",
          "Toutes les communications entre votre navigateur et nos serveurs sont chiffrées (protocole HTTPS). Vos mots de passe ne sont jamais stockés en clair et sont sécurisés par hachage cryptographique. Aucune donnée bancaire (numéro de carte, IBAN complet, CVV) n'est stockée sur nos serveurs : tous les paiements sont traités directement par Stripe, certifié aux normes de sécurité bancaire les plus strictes (PCI-DSS niveau 1).",
          "Les professionnels ne peuvent accéder qu'à leurs propres données et celles de leurs clients. L'accès à notre base de données est strictement contrôlé et nos équipes sont formées aux bonnes pratiques de protection des données."
        ],
        note: "Malgré toutes ces mesures, aucun système n'est totalement infaillible. En cas de violation de données personnelles susceptible de présenter un risque élevé pour vos droits et libertés, nous vous en informerons dans les meilleurs délais conformément au RGPD et notifierons la CNIL dans les 72 heures."
      },
      retention: {
        title: "7. Durée de Conservation des Données",
        intro: "Nous conservons vos données personnelles uniquement pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées, dans le respect des obligations légales :",
        items: [
          "Comptes professionnels actifs : Pendant toute la durée de votre abonnement et jusqu'à la suppression de votre compte. En cas d'inactivité (aucune connexion pendant 3 ans), nous vous contacterons avant toute suppression.",
          "Données clients (réservations) : 3 ans après la dernière réservation (durée nécessaire pour la gestion des réclamations et la responsabilité contractuelle).",
          "Données de paiement et facturation : 10 ans à compter de la clôture de l'exercice comptable, conformément aux obligations fiscales et comptables (articles L123-22 du Code de commerce). Cela inclut : factures d'abonnement, historique des paiements, remboursements, données Stripe.",
          "Mots de passe et tokens : Les mots de passe hachés sont conservés tant que le compte existe. Les tokens JWT expirent automatiquement (1h pour access token, 7j pour refresh token).",
          "Images et fichiers (AWS S3) : Conservés tant que le compte professionnel est actif. Supprimés dans les 30 jours suivant la suppression du compte (sauf obligation légale de conservation).",
          "Avis clients : Conservés indéfiniment tant que le compte professionnel existe, car ils constituent un élément de réputation publique. Supprimés uniquement sur demande motivée ou en cas de suppression du compte professionnel.",
          "Logs et données techniques : Conservation maximale de 30 jours pour les logs de connexion et d'utilisation, sauf en cas d'incident de sécurité nécessitant une investigation.",
          "Données après suppression de compte : Après suppression d'un compte professionnel, certaines données sont conservées en archive pour respecter les obligations légales (factures, historique de paiements pour 10 ans). Les données personnelles non soumises à obligation légale sont supprimées définitivement dans les 30 jours."
        ],
        note: "À l'expiration des durées de conservation, vos données sont soit supprimées définitivement, soit anonymisées de manière irréversible (ce qui signifie qu'elles ne peuvent plus être rattachées à votre identité). Les professionnels et les clients peuvent demander la suppression anticipée de leurs données en nous contactant via le chatBot ou à l'adresse contact-pro@prestaslot.com, sous réserve des obligations légales de conservation."
      },
      rights: {
        title: "8. Vos Droits (RGPD)",
        intro: "Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez des droits suivants concernant vos données personnelles :",
        items: [
          "Droit d'accès (art. 15 RGPD) : Vous pouvez obtenir la confirmation que vos données sont traitées, accéder à vos données personnelles et recevoir une copie de celles-ci. Vous pouvez également obtenir des informations sur les finalités du traitement, les catégories de données, les destinataires, les durées de conservation.",
          "Droit de rectification (art. 16 RGPD) : Vous pouvez demander la correction de données inexactes ou incomplètes vous concernant. Les professionnels peuvent directement modifier la plupart de leurs informations depuis leur espace personnel.",
          "Droit à l'effacement / droit à l'oubli (art. 17 RGPD) : Vous pouvez demander la suppression de vos données dans certains cas (données non nécessaires, retrait du consentement, opposition au traitement, traitement illicite). Attention : ce droit n'est pas absolu et peut être limité par nos obligations légales (conservation des factures pendant 10 ans, par exemple).",
          "Droit à la limitation du traitement (art. 18 RGPD) : Vous pouvez demander le gel temporaire du traitement de vos données dans certaines situations (contestation de l'exactitude, traitement illicite mais opposition à l'effacement, données nécessaires pour une action en justice).",
          "Droit à la portabilité (art. 20 RGPD) : Vous pouvez recevoir vos données dans un format structuré, couramment utilisé et lisible par machine (JSON, CSV) et les transmettre à un autre responsable de traitement. Ce droit s'applique uniquement aux données que vous avez fournies et dont le traitement est fondé sur votre consentement ou un contrat.",
          "Droit d'opposition (art. 21 RGPD) : Vous pouvez vous opposer au traitement de vos données pour des raisons tenant à votre situation particulière, notamment lorsque le traitement est fondé sur notre intérêt légitime. Vous pouvez également vous opposer au traitement à des fins de prospection commerciale (si applicable).",
          "Droit de ne pas faire l'objet d'une décision automatisée (art. 22 RGPD) : Vous avez le droit de ne pas faire l'objet d'une décision fondée exclusivement sur un traitement automatisé produisant des effets juridiques vous concernant. Note : PrestaSlot n'utilise pas de prise de décision entièrement automatisée.",
          "Droit de définir des directives post-mortem (art. 40-1 Loi Informatique et Libertés) : Vous pouvez définir des directives relatives au sort de vos données après votre décès."
        ],
        contact: "Pour exercer l'un de ces droits ou pour toute question concernant la protection de vos données personnelles, vous pouvez nous contacter : • Via le chatBot disponible sur notre plateforme • Par email : contact-pro@prestaslot.com • Par courrier : PrestaSlot - Indemba Emmanuel, [adresse complète]. Nous nous engageons à répondre à votre demande dans un délai maximum d'un mois. Ce délai peut être prolongé de deux mois compte tenu de la complexité et du nombre de demandes. Nous pouvons vous demander une preuve d'identité pour traiter votre demande et éviter toute usurpation.",
        complaint: "Droit de réclamation auprès de l'autorité de contrôle : Si vous estimez que vos droits ne sont pas respectés ou que le traitement de vos données personnelles n'est pas conforme au RGPD, vous avez le droit d'introduire une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL) : • En ligne : www.cnil.fr • Par courrier : CNIL - 3 Place de Fontenoy - TSA 80715 - 75334 PARIS CEDEX 07 • Par téléphone : 01 53 73 22 22"
      },
      cookies: {
        title: "9. Cookies et Stockage Local",
        content: [
          "PrestaSlot utilise des technologies de stockage local dans votre navigateur pour assurer le bon fonctionnement de la plateforme et améliorer votre expérience utilisateur.",
          "Nous stockons des informations de session dans votre navigateur (localStorage) pour vous maintenir connecté lorsque vous naviguez sur la plateforme, ainsi que vos préférences linguistiques (français ou anglais). Ces informations ne contiennent aucune donnée sensible.",
          "Lors du processus de paiement, des cookies Stripe peuvent être déposés pour sécuriser vos transactions. Consultez la politique de cookies de Stripe sur stripe.com. Notre hébergeur (Vercel) peut également générer des cookies techniques pour des raisons de sécurité et de performance.",
          "Vous pouvez à tout moment supprimer ces données en vous déconnectant de votre compte ou en vidant le cache de votre navigateur."
        ],
        note: "PrestaSlot n'utilise PAS de cookies de tracking ou de publicité ciblée (Google Analytics, Facebook Pixel, etc.). Le stockage local est limité au strict nécessaire pour le fonctionnement du service."
      },
      updates: {
        title: "10. Modifications de la Politique de Confidentialité",
        content: [
          "Nous pouvons mettre à jour cette politique de confidentialité de temps à autre pour refléter les évolutions de notre service, de la législation en vigueur (RGPD, loi Informatique et Libertés) ou de nos pratiques en matière de traitement des données.",
          "En cas de modification substantielle (nouvelles finalités de traitement, nouveaux destinataires de données, changements affectant vos droits), nous vous en informerons par email à l'adresse enregistrée dans votre compte et/ou par une notification visible sur la plateforme, au moins 30 jours avant l'entrée en vigueur des changements.",
          "Les modifications mineures (corrections typographiques, clarifications, mises à jour de coordonnées) seront simplement publiées sur cette page avec mise à jour de la date de \"Dernière mise à jour\" en haut de cette politique.",
          "Nous vous encourageons à consulter régulièrement cette page pour rester informé de la manière dont nous protégeons vos données personnelles. La poursuite de l'utilisation de nos services après l'entrée en vigueur de modifications substantielles vaut acceptation de la nouvelle politique de confidentialité."
        ]
      },
      minors: {
        title: "11. Protection des Mineurs",
        content: [
          "PrestaSlot est un service destiné aux personnes majeures (18 ans et plus). Nous ne collectons pas sciemment d'informations personnelles directement auprès de mineurs sans le consentement d'un parent ou tuteur légal.",
          "Réservations pour mineurs : Les parents ou tuteurs légaux peuvent effectuer des réservations pour des services destinés à des mineurs (par exemple, un parent réservant un rendez-vous pour son enfant mineur). Dans ce cas, c'est le parent/tuteur qui fournit les données personnelles et qui agit au nom du mineur sous sa responsabilité.",
          "Si nous apprenons que nous avons collecté des données personnelles directement auprès d'un utilisateur de moins de 18 ans sans consentement parental vérifiable, nous prendrons immédiatement des mesures pour supprimer ces informations de nos serveurs.",
          "Si vous êtes parent ou tuteur légal et que vous apprenez que votre enfant nous a fourni des données personnelles sans votre consentement, veuillez nous contacter immédiatement à contact-pro@prestaslot.com afin que nous puissions prendre les mesures appropriées."
        ]
      },
      international: {
        title: "12. Transferts Internationaux de Données",
        content: [
          "Localisation des données : Nos serveurs principaux et notre base de données PostgreSQL sont hébergés dans l'Union Européenne. Les fichiers (images) sont stockés sur AWS S3 dans la région EU (eu-north-1, Suède).",
          "Transferts vers les États-Unis : Certains de nos prestataires techniques sont basés aux États-Unis : Stripe Inc. (paiements et abonnements) : Stripe est certifié conforme au RGPD et applique les Clauses Contractuelles Types (CCT) approuvées par la Commission Européenne pour encadrer les transferts de données. Politique de confidentialité : stripe.com/privacy. Vercel Inc. (hébergement frontend) : Les données personnelles ne sont pas directement stockées chez Vercel, uniquement le code de l'application et les assets statiques. Les logs de connexion (IP, user-agent) peuvent être collectés conformément à leur politique.",
          "Garanties appropriées : Pour tous les transferts de données en dehors de l'Union Européenne, nous veillons à mettre en place des garanties appropriées conformément à l'article 46 du RGPD (Clauses Contractuelles Types, certifications, accords de transfert)."
        ]
      },
      contact: {
        title: "13. Contact et Délégué à la Protection des Données",
        content: [
          "Pour toute question concernant cette politique de confidentialité, le traitement de vos données personnelles ou l'exercice de vos droits RGPD, vous pouvez nous contacter :",
          "Responsable du traitement : Indemba Emmanuel - PrestaSlot",
          "Email : contact-pro@prestaslot.com",
          "Via le chatBot disponible sur notre plateforme",
          "Note : Compte tenu de la taille de notre structure, nous n'avons pas désigné de Délégué à la Protection des Données (DPO) dédié. Le responsable du traitement assure lui-même cette fonction."
        ]
      }
    }
  };
  
export const onboarding = {
    dashboard: {
        left: "Bienvenue sur ton tableau de bord ! Ici, tu as tous tes rendez-vous du jour filtrés par statut. En cliquant sur les trois points du rendez-vous, tu peux annuler le rendez-vous ou le signaler comme terminé.",
        right: "Ici, tu peux créer un nouveau rendez-vous.",
        bottom: "Ici, tu peux voir aller voir tes disponibilités.",
        revenue: "Ici, tu peux voir tes recettes du jour.",
    },
    calendar: {
        left: "Ici, tu peux voir tous tes rendez-vous sur une période illimitée et basculer entre la vue semaine et la vue jour.",
        right: "Ici, tu peux ajouter un rendez-vous. Les rendez-vous sont affichés dans les cellules tu peux en sélectionner un et l'annuler si tu le souhaites.",
    },
    reservation: {
        left: "Tes rendez-vous s'affichent ici. Tu peux cliquer sur un rendez-vous ou les trois points pour voir ses détails.",
        filterWeek: "Tu peux filtrer tes rendez-vous par jour, semaine et mois.",
        filterStatus: "Filtrer ensuite tes rendez-vous par statut.",
        stats: "Enfin, tu peux voir les statistiques de tes rendez-vous en fonction des filtrages précédents.",
    },
    services: {
        filterStatus: "Filtrer ensuite tes prestations par statut.",
        filterSearch: "Ou sinon, tu peux rechercher une prestation.",
        view: "Tes prestations s'affichent ici. Tu peux visualiser une prestation via l'icône oeil, la modifier via l'icône crayon, la supprimer via l'icône poubelle ou l'activer/désactiver via le switch.",
        add: "Clique sur ce bouton pour ajouter une prestation, ensuite tu pourras ajouter des catégories qui regrouperont des options de prestations (l'ajout des catégories et des options est optionnel).",
    },
    profile: {
        update: "Clique sur ce bouton avant de pouvoir modifier tes informations dans chaque section.",
        personalInfo: "Rentre ton siren, les autres informations seront pré-remplies. Veille à remplir le reste des informations personnelles dans la section Profil personnel. La timezone est par défaut sur Europe/Paris tu peux la modifier si tu le souhaites.",
    },
    availability: {
        timezone: "Ta timezone est affichée ici, tu peux la modifier via ton profil si tu le souhaites.",
        link: "Ton lien de réservation est affiché ici, tu peux le copier et le partager sur tes profils pour permettre aux clients de prendre rendez-vous.",
        add: "Clique sur ce bouton pour ajouter tes disponibilités récurrentes ou ponctuelles.",
        view: "Tes disponibilités s'affichent ici. Tes disponibilités récurrentes sont affichées en vert et tes disponibilités ponctuelles en bleu.",
        navigate: "Tu peux naviguer entre les mois via les boutons de navigation pour voir tes disponibilités sur une période illimitée.",
    },
    skip: "Passer le tutoriel",
    next: "Suivant",
    back: "Précédent",
    close: "Fermer",
    last: "Terminer"
}

export const reviews = {
  // review côté client
  missingToken: "Le token est manquant",
  title: "Donne ton avis !",
  rateExperience: "Notez votre expérience",
  commentPlaceholder: "Partagez votre expérience (optionnel)",
  submit: "Envoyer en cours...",
  send: "Envoyer",
  loading: "Chargement en cours...",
  tokenExpired: "Le lien a expiré",
  tokenUsed: "Vous avez déjà laissé un avis",
  tokenInvalid: "Le lien est invalide",
  tokenExpiredMessage: "Le lien pour laisser votre avis a expiré. Les liens sont valables pendant 7 jours après votre rendez-vous.",
  tokenUsedMessage: "Vous avez déjà laissé un avis pour ce rendez-vous. Merci pour votre participation !",
  tokenInvalidMessage: "Le lien que vous avez utilisé n'est pas valide. Veuillez vérifier l'URL ou contacter le professionnel.",
  thankYou: "Merci pour votre avis !",
  feedbackReceived: "Votre avis a bien été enregistré et sera visible prochainement.",
  previous: "Page précédente",
  next: "Page suivante",
  noReviews: "Aucun avis pour le moment",
  basedOn: "Basé sur {{count}} avis",
  ratingDistribution: "Distribution des notes",
  titleReview: "Avis clients",
  description: "Découvrez ce que nos clients pensent de ce professionnel et de ses services.",
  bookNow: "Réserver maintenant",
  professionalReply: "Réponse du professionnel",
  noProfessionalId: "Identifiant du professionnel manquant",
  titleProReview: "Avis client | PrestaSlot",
  titleWithProName: "Avis pour {{name}}",
  withProfessional: "Consultez les avis clients vérifiés pour {{name}}. Moyenne de {{average}}/5 basée sur {{count}} avis.",
  general: "Consultez les avis clients vérifiés de nos professionnels sur PrestaSlot.",
  viewAll: "Voir tous les avis",

  // review pro
  pageTitle: "Avis clients",
  refreshing: "Actualisation...",
  refresh: "Actualiser",
  bookingDate: "Réservation du",
  yourReply: "Votre réponse",
  modifyReply: "Modifier ma réponse",
  replyReview: "Répondre à cet avis",
  writeYourReply: "Écrivez votre réponse ici...",
  sending: "Envoi...",
  cancel: "Annuler",
  search: "Rechercher dans les avis...",
  filter: {
    all: "Tous les avis",
    withResponse: "Avec réponse",
    withoutResponse: "Sans réponse"
  },
  noReviewsFound: "Aucun avis ne correspond à votre recherche",
  displaying: "Affichage de",
  of: "de",
  reviews: "avis",
  noStats: "Aucune statistique disponible",
  stats: "Statistiques des avis",
  totalReviews: "avis au total"
}

export const subscription = {
  title: "Abonnement",
  subtitle: "Gérez votre abonnement et choisissez le plan qui vous convient",
  loading: "Chargement...",

  // Plans
  choosePlanTitle: "Choisissez votre plan",
  choosePlanDescription: "Sélectionnez le plan qui correspond le mieux à vos besoins",
  changePlanTitle: "Changer de plan",
  changePlanDescription: "Passez à un plan supérieur ou inférieur selon vos besoins",

  // Plan Card
  popular: "Populaire",
  current: "Actuel",
  currentPlan: "Plan actuel",
  currentPlanTitle: "Votre abonnement actuel",
  selectPlan: "Choisir ce plan",
  contactUs: "Nous contacter",
  customPrice: "Sur devis",
  perMonth: "/mois",

  // Features
  features: {
    companies: "{{count}} entreprise",
    companies_plural: "{{count}} entreprises",
    collaborators: "{{count}} collaborateur",
    collaborators_plural: "{{count}} collaborateurs",
    services: "{{count}} service",
    services_plural: "{{count}} services",
    bookings: "{{count}} réservations/mois",
    bookingsUnlimited: "Réservations illimitées",
    promoCodes: "{{count}} code promo actif",
    promoCodes_plural: "{{count}} codes promo actifs",
    promoCodesUnlimited: "Codes promo illimités",
    onlinePayment: "Paiement en ligne",
    depositPayment: "Paiement d'acompte",
    reviewSystem: "Système d'avis",
    advancedAnalytics: "Analyses avancées",
    customBranding: "Personnalisation de la marque",
    prioritySupport: "Support prioritaire",
    apiAccess: "Accès API",
    whiteLabel: "White Label"
  },

  // Status
  status: {
    active: "Actif",
    trialing: "Période d'essai",
    pastDue: "En retard",
    canceled: "Annulé",
    incomplete: "Incomplet"
  },

  // Actions
  managePlan: "Gérer votre plan et vos options",
  manageBilling: "Gérer la facturation",
  changeSubscription: "Changer l'abonnement",
  cancelPlan: "Annuler l'abonnement",
  reactivate: "Réactiver",
  yourPlan: "Votre plan",
  billingPeriod: "Période de facturation",
  trialEnds: "Fin de la période d'essai",

  // Messages
  successTitle: "Abonnement activé !",
  successMessage: "Votre abonnement a été activé avec succès. Vous pouvez maintenant profiter de toutes les fonctionnalités de votre plan.",
  validUntil: "Valide jusqu'au {{date}}",
  cancelWarning: "Abonnement en cours d'annulation",
  cancelDescription: "Votre abonnement restera actif jusqu'au {{date}}",

  // Confirmations
  confirmChange: "Êtes-vous sûr de vouloir changer de plan ?",
  confirmUpgrade: "Passer à ce plan améliorera immédiatement vos limites. Continuer ?",
  confirmDowngrade: "Réduire votre plan peut limiter certaines fonctionnalités. Êtes-vous sûr ?",
  changePlanConfirmTitle: "Changer de plan",
  changePlanConfirmYes: "Oui, changer",
  changePlanConfirmNo: "Non, annuler",
  cancelConfirmTitle: "Annuler l'abonnement",
  cancelConfirmMessage: "Votre abonnement restera actif jusqu'à la fin de la période en cours. Vous pourrez le réactiver à tout moment.",
  cancelConfirmYes: "Oui, annuler",
  cancelConfirmNo: "Non, conserver",

  // Plan Multi
  multiPlanDescription: "Tarif personnalisé selon vos besoins",
  multiContactBody: "Bonjour ! Je suis intéressé(e) par le plan Multi et souhaiterais obtenir un devis personnalisé. Pouvez-vous m'aider ?",

  // Limits
  limits: {
    usage: "Utilisation",
    upgrade: "Améliorer mon plan",
    upgradeTitle: "Avantages d'un plan supérieur",
    benefit1: "Augmentez vos limites immédiatement",
    benefit2: "Accédez à des fonctionnalités avancées",
    benefit3: "Développez votre activité sans contraintes",
    cancel: "Pas maintenant",

    companies: {
      title: "Limite d'entreprises atteinte",
      description: "Vous avez atteint la limite de {{limit}} entreprise(s) pour votre plan actuel ({{current}}/{{limit}})."
    },
    collaborators: {
      title: "Limite de collaborateurs atteinte",
      description: "Vous avez atteint la limite de {{limit}} collaborateur(s) pour votre plan actuel ({{current}}/{{limit}})."
    },
    services: {
      title: "Limite de services atteinte",
      description: "Vous avez atteint la limite de {{limit}} service(s) pour votre plan actuel ({{current}}/{{limit}})."
    },
    promoCodes: {
      title: "Limite de codes promo atteinte",
      description: "Vous avez atteint la limite de {{limit}} code(s) promo actif(s) pour votre plan actuel ({{current}}/{{limit}})."
    },
    generic: {
      title: "Limite atteinte",
      description: "Vous avez atteint la limite de votre plan actuel ({{current}}/{{limit}})."
    }
  }
}

export const billing = {
  title: "Facturation",
  subtitle: "Gérez vos factures et moyens de paiement",

  // Subscription Management
  subscriptionManagement: "Gestion de l'abonnement",
  subscriptionDescription: "Consultez et modifiez votre abonnement",
  currentPlan: "Plan actuel",
  noSubscription: "Aucun abonnement actif",
  manageSubscription: "Gérer mon abonnement",
  chooseSubscription: "Choisir un abonnement",
  perMonth: "/mois",

  feature1: "Gérer votre plan et vos limites",
  feature2: "Passer à un plan supérieur ou inférieur",
  feature3: "Annuler votre abonnement à tout moment",

  // Invoices & Payments
  invoicesPayments: "Factures et paiements",
  invoicesDescription: "Accédez à vos factures et historique",
  stripePortalDescription: "Le portail Stripe vous permet de gérer facilement tous les aspects de votre facturation en toute sécurité.",

  portalFeature1: "Télécharger vos factures",
  portalFeature2: "Mettre à jour vos moyens de paiement",
  portalFeature3: "Consulter l'historique de facturation",
  portalFeature4: "Gérer les informations de facturation",

  openStripePortal: "Ouvrir le portail Stripe",
  requiresSubscription: "Nécessite un abonnement actif",
  loading: "Chargement...",

  // Security
  securityTitle: "Paiements sécurisés",
  securityDescription: "Toutes les transactions sont sécurisées par Stripe, leader mondial du paiement en ligne. Vos informations bancaires ne sont jamais stockées sur nos serveurs."
}

export const stripe = {
  title: "Stripe Connect",
  description: "Configurez votre compte Stripe pour recevoir les paiements de vos clients",
  loading: "Chargement...",

  // Account Status
  accountStatus: "Statut de votre compte",
  accountStatusDescription: "Informations sur votre compte Stripe Connect",

  // Status badges
  status: {
    notConfigured: "Non configuré",
    pending: "En cours de vérification",
    verified: "Vérifié",
    restricted: "Restreint"
  },

  // Capabilities
  capabilities: {
    charges: "Accepter les paiements",
    chargesEnabled: "Vous pouvez accepter des paiements",
    chargesDisabled: "Non activé",
    payouts: "Recevoir des virements",
    payoutsEnabled: "Vous pouvez recevoir des virements",
    payoutsDisabled: "Non activé",
    details: "Informations soumises",
    detailsSubmitted: "Informations complètes",
    detailsNotSubmitted: "Informations manquantes"
  },

  // Requirements
  requirements: {
    pastDue: "Action requise immédiatement",
    pastDueDescription: "Certaines informations sont en retard. Veuillez compléter votre compte pour continuer à accepter des paiements.",
    currentlyDue: "Informations requises",
    currentlyDueDescription: "Veuillez compléter votre compte pour activer tous les services."
  },

  // Buttons
  button: {
    configureStripe: "Configurer Stripe",
    completeOnboarding: "Compléter la configuration",
    openDashboard: "Ouvrir le dashboard Stripe"
  },

  // Not configured state
  notConfigured: {
    title: "Compte Stripe non configuré",
    description: "Configurez votre compte Stripe Connect pour commencer à recevoir des paiements en ligne de vos clients. Le processus est simple et sécurisé."
  },

  // Fees information
  fees: {
    title: "Frais de transaction",
    description: "Comment fonctionnent les frais de paiement ?",
    modes: "Modes de gestion des frais",
    mode1Title: "J'absorbe les frais de service",
    mode1Description: "Le client paie uniquement le prix du service. Les frais de service (~1,5% + 0,25€) sont déduits de votre revenu.",
    mode2Title: "Je répercute les frais au client",
    mode2Description: "Un markup de 2% est ajouté au prix pour couvrir les frais de service. Vous recevez 100% du prix du service.",
    stripe: "Frais de service : ~1,5% + 0,25€",
    stripeDescription: "Les frais de service sont ajoutés au montant de la prestation et payés par le client. Vous recevez 100% du prix de votre prestation.",
    platform: "Commission plateforme : 0€",
    platformDescription: "Aucune commission n'est prélevée par PrestaSlot. Vous gardez l'intégralité du montant de vos prestations.",
    changeSetting: "Changez de mode",
    changeSettingDescription: "Vous pouvez basculer entre les deux modes à tout moment via le toggle \"Gestion des frais de transaction\" sur cette page."
  },

  // Pricing example
  example: {
    title: "Exemple de tarification",
    servicePrice: "Prix de la prestation",
    stripeFee: "Frais de service (ajoutés au total)",
    clientPays: "Le client paie",
    youReceive: "Vous recevez"
  },

  // Revenue statistics
  revenueStats: {
    title: "Statistiques de revenus",
    totalRevenue: "Revenus totaux",
    totalTransactions: "Nombre de paiements",
    averageTransaction: "Montant moyen",
    totalStripeFees: "Frais de service"
  }
}

export const payment = {
  // Common
  verifying: "Vérification du paiement...",
  pleaseWait: "Veuillez patienter",
  error: "Erreur",
  backToHome: "Retour à l'accueil",

  // Success page
  successTitle: "Paiement réussi !",
  successMessage: "Votre paiement a été traité avec succès",
  details: "Détails du paiement",
  amount: "Montant",
  status: "Statut",
  paymentId: "ID de paiement",
  paid: "Payé",
  confirmationEmail: "Un e-mail de confirmation a été envoyé à votre adresse e-mail avec tous les détails de votre réservation.",
  viewBooking: "Voir ma réservation",
  bookAnother: "Prendre un autre rendez-vous",

  // Cancel page
  cancelTitle: "Paiement annulé",
  cancelMessage: "Vous avez annulé le processus de paiement",
  whatHappensNow: "Que se passe-t-il maintenant ?",
  cancelInfo1: "Votre réservation n'a pas été confirmée",
  cancelInfo2: "Aucun montant n'a été débité de votre compte",
  cancelInfo3: "Vous pouvez reprendre le processus de réservation à tout moment",
  cancelledPaymentDetails: "Détails du paiement annulé",
  cancelled: "Annulé",
  needHelp: "Besoin d'aide ? Contactez-nous si vous rencontrez des difficultés lors du processus de paiement.",
  tryAgain: "Réessayer",
  backToBooking: "Page de réservation",
  loading: "Chargement...",
}
